import gql from "graphql-tag";

//--------
// FRAGMENTS
//--------

//--------
// QUERIES
//--------

//TODO: REMOVE BECAUSE UNUSED
export const allProductsQuery = gql`
  query allProductsQuery($lang: String!) {
    productQuery(filter: { status: true, langcode: $lang }, limit: 9999999999) {
      entities {
        ... on Product {
          name
          fieldLastModifiedDate
          fieldLongDescription {
            processed
          }
          fieldAbstract {
            value
          }
          status
          entityCreated
          entityLanguage {
            id
            name
          }
          fieldAvailability
          fieldCode
          fieldProductLanguage {
            entity {
              name
            }
          }
          fieldMaxShopQuantity
          fieldReShoppableNote {
            processed
          }
          fieldPdfProduct {
            entity {
              url
            }
          }
          fieldLinkToPdf {
            url {
              path
            }
          }
          fieldProductCategory {
            targetId
            entity {
              entityLabel
            }
          }
          fieldPrices {
            entity {
              ... on ParagraphPrice {
                id
                fieldPriceAmount
                fieldCurrency
              }
            }
          }
          fieldSizes {
            targetId
            entity {
              ... on ParagraphSize {
                fieldSizeName
              }
            }
          }
          entityId
          fieldProductImages {
            url
            width
            height
            alt
            title
            targetId
          }
          fieldPackageProductsRef {
            targetId
            quantity
            entity {
              ... on Product {
                name
                fieldAbstract {
                  value
                }
                status
                entityLanguage {
                  id
                  name
                }
                fieldAvailability
                fieldCode
                fieldMaxShopQuantity
                fieldPdfProduct {
                  entity {
                    url
                  }
                }
                fieldProductCategory {
                  targetId
                  entity {
                    entityLabel
                  }
                }
                fieldLinkToPdf {
                  url {
                    path
                  }
                }
                fieldSizes {
                  targetId
                  entity {
                    ... on ParagraphSize {
                      fieldSizeName
                    }
                  }
                }
                entityId
                fieldProductImages {
                  url
                  width
                  height
                  alt
                  title
                  targetId
                }
              }
            }
          }
        }
      }
      count
    }
  }
`;

export const productByIDQuery = gql`
  query productByIDQuery($id: String!, $lang: LanguageId!) {
    productById(id: $id, language: $lang) {
      ... on Product {
        id
        name
        fieldLastModifiedDate
        fieldLongDescription {
          processed
        }
        fieldAbstract {
          value
        }
        status
        entityCreated
        entityLanguage {
          id
          name
        }
        fieldAvailability
        fieldCode
        fieldMaxShopQuantity
        fieldReShoppableNote {
          processed
        }
        fieldPdfProduct {
          entity {
            url
          }
        }
        fieldLinkToPdf {
          url {
            path
          }
        }
        fieldProductCategory {
          targetId
          entity {
            entityLabel
          }
        }
        fieldSizes {
          targetId
          entity {
            ... on ParagraphSize {
              fieldSizeName
            }
          }
        }
        fieldPrices {
          entity {
            ... on ParagraphPrice {
              id
              fieldPriceAmount
              fieldCurrency
            }
          }
        }
        fieldProductImages {
          url
          width
          height
          alt
          title
          targetId
        }
        fieldPackageProductsRef {
          targetId
          quantity
          entity {
            ... on Product {
              name
              fieldAbstract {
                value
              }
              status
              entityLanguage {
                id
                name
              }
              fieldAvailability
              fieldCode
              fieldMaxShopQuantity
              fieldPdfProduct {
                entity {
                  url
                }
              }
              fieldLinkToPdf {
                url {
                  path
                }
              }
              fieldSizes {
                targetId
                entity {
                  ... on ParagraphSize {
                    fieldSizeName
                  }
                }
              }
              entityId
              fieldProductImages {
                url
                width
                height
                alt
                title
                targetId
              }
              fieldProductCategory {
                targetId
                entity {
                  entityLabel
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getSummaryProducts = gql`
  query productsFiltered(
    $tid: String!
    $page: Int!
    $pageSize: Int!
    $lang: String!
  ) {
    productListGraphql1View(
      page: $page
      pageSize: $pageSize
      filter: { field_product_category_target_id: $tid, langcode: $lang }
    ) {
      count
      results {
        ... on Product {
          name
          fieldAbstract {
            value
          }
          fieldCode
          fieldProductImages {
            url
            alt
            title
            targetId
          }
          entityId
        }
      }
    }
  }
`;

export const productsFiltered = gql`
  query productsFiltered(
    $tid: String!
    $page: Int!
    $pageSize: Int!
    $lang: String!
    $orderField: ProductListGraphql1ViewSortBy = NAME
    $productCategoryFilter: [String!]! = []
    $productLanguageFilter: [String!]! = []
  ) {
    productListGraphql1View(
      page: $page
      pageSize: $pageSize
      filter: {
        field_product_category_target_id: $productCategoryFilter
        field_product_language_target_id: $productLanguageFilter
        parent: { value: $tid }
        langcode: $lang
      }
      sortBy: $orderField
      sortDirection: ASC
    ) {
      count
      results {
        ... on Product {
          name
          fieldLastModifiedDate
          fieldLongDescription {
            processed
          }
          fieldAbstract {
            value
          }
          status
          entityCreated
          entityLanguage {
            id
            name
          }
          fieldAvailability
          fieldCode
          fieldProductLanguage {
            entity {
              name
            }
          }
          fieldMaxShopQuantity
          fieldReShoppableNote {
            processed
          }
          fieldPdfProduct {
            entity {
              url
            }
          }
          fieldLinkToPdf {
            url {
              path
            }
          }
          fieldProductCategory {
            targetId
            entity {
              entityLabel
            }
          }
          fieldSizes {
            targetId
            entity {
              ... on ParagraphSize {
                fieldSizeName
              }
            }
          }
          fieldPrices {
            entity {
              ... on ParagraphPrice {
                id
                fieldPriceAmount
                fieldCurrency
              }
            }
          }
          fieldProductImages {
            url
            width
            height
            alt
            title
            targetId
          }
          entityId
          fieldPackageProductsRef {
            targetId
            quantity
            entity {
              ... on Product {
                name
                fieldAbstract {
                  value
                }
                status
                entityLanguage {
                  id
                  name
                }
                fieldAvailability
                fieldCode
                fieldMaxShopQuantity
                fieldPdfProduct {
                  entity {
                    url
                  }
                }
                fieldLinkToPdf {
                  url {
                    path
                  }
                }
                fieldSizes {
                  targetId
                  entity {
                    ... on ParagraphSize {
                      fieldSizeName
                    }
                  }
                }
                entityId
                fieldProductImages {
                  url
                  width
                  height
                  alt
                  title
                  targetId
                }
                fieldProductCategory {
                  targetId
                  entity {
                    entityLabel
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const productCategories = gql`
  query productCategories($lang: String!) {
    feNavigationMenuTermsGraphql1View(filter: { langcode: $lang }) {
      results {
        tid
        weight
        name
      }
    }
  }
`;

export const lastInsertedProducts = gql`
  query lastInsertedProducts($tid: String!, $langcode: String) {
    lastInsertedProductsGraphql1View(
      filter: {
        field_product_category_target_id: $tid
        parent: { value: $tid }
        langcode: $langcode
      }
    ) {
      results {
        ... on Product {
          fieldProductImages {
            url
            width
            height
            alt
            title
            targetId
          }
          name
          entityId
          fieldCode
        }
      }
    }
  }
`;

export const childTerms = gql`
  query childTerms($tid: String!, $lang: String!) {
    childtermsGraphql1View(
      filter: { parent: { value: $tid }, langcode: $lang }
    ) {
      results {
        tid
        name
      }
    }
  }
`;

export const productSearch = gql`
  query productSearch(
    $name: String
    $page: Int
    $pageSize: Int
    $lang: String!
  ) {
    productSearchGraphql1View(
      page: $page
      pageSize: $pageSize
      filter: { name: $name, langcode: $lang }
    ) {
      count
      results {
        ... on Product {
          name
          fieldLastModifiedDate
          fieldLongDescription {
            processed
          }
          fieldAbstract {
            value
          }
          status
          entityCreated
          entityLanguage {
            id
            name
          }
          fieldAvailability
          fieldCode
          fieldProductLanguage {
            entity {
              name
            }
          }
          fieldMaxShopQuantity
          fieldPdfProduct {
            entity {
              url
            }
          }
          fieldLinkToPdf {
            url {
              path
            }
          }
          fieldProductCategory {
            targetId
            entity {
              entityLabel
            }
          }
          fieldSizes {
            targetId
            entity {
              ... on ParagraphSize {
                fieldSizeName
              }
            }
          }
          fieldPrices {
            entity {
              ... on ParagraphPrice {
                id
                fieldPriceAmount
                fieldCurrency
              }
            }
          }
          fieldProductImages {
            url
            width
            height
            alt
            title
            targetId
          }
          entityId
          fieldPackageProductsRef {
            targetId
            quantity
            entity {
              ... on Product {
                name
                fieldAbstract {
                  value
                }
                status
                entityLanguage {
                  id
                  name
                }
                fieldAvailability
                fieldCode
                fieldMaxShopQuantity
                fieldPdfProduct {
                  entity {
                    url
                  }
                }
                fieldLinkToPdf {
                  url {
                    path
                  }
                }
                fieldSizes {
                  targetId
                  entity {
                    ... on ParagraphSize {
                      fieldSizeName
                    }
                  }
                }
                entityId
                fieldProductImages {
                  url
                  width
                  height
                  alt
                  title
                  targetId
                }
                fieldProductCategory {
                  targetId
                  entity {
                    entityLabel
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const productByCode = gql`
  query productByCode($code: String!) {
    productcodeGraphql1View(filter: { field_code_value: $code }) {
      results {
        ... on Product {
          name
          entityCreated
          entityId
          fieldAvailability
          fieldMaxShopQuantity
          fieldProductImages {
            url
          }
        }
      }
    }
  }
`;

export const getSimilarProducts = gql`
  query ProductsForCategoryExcludedOne(
    $tid: String!
    $categories_tids: String!
  ) {
    filteredProductsGraphqlExcludedOneView(
      contextualFilter: {
        field_product_category_target_id: $tid # Da escludere
        field_product_category_target_id_1: $categories_tids
      }
    ) {
      results {
        ... on Product {
          entityId
          entityLabel
          fieldCode
          fieldPrices
          fieldAbstract {
            value
          }
          fieldProductImages {
            url
            width
            height
            alt
            title
            targetId
          }
          name
        }
      }
    }
  }
`;

export const getQuantitiesByRegion = gql`
  query ProductsGraphqlAmountxRegion(
    $field_product_category_target_id: [String]
    $id: IdMultiViewFilterInput
    $name: String
  ) {
    filteredProductsGraphqlAmountxRegionView(
      filter: {
        field_product_category_target_id: $field_product_category_target_id
        id: $id
        name: $name
      }
    ) {
      results {
        id
        field_amount
        field_region
        region_tid
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/products.js